import { render, staticRenderFns } from "./Pnr.vue?vue&type=template&id=4b5c32cf&"
import script from "./Pnr.vue?vue&type=script&lang=js&"
export * from "./Pnr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b5c32cf')) {
      api.createRecord('4b5c32cf', component.options)
    } else {
      api.reload('4b5c32cf', component.options)
    }
    module.hot.accept("./Pnr.vue?vue&type=template&id=4b5c32cf&", function () {
      api.rerender('4b5c32cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Input/Pnr.vue"
export default component.exports